import { Link, useLocation } from 'react-router-dom';
import useSeo from '@/hooks/useSeo';

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: '页面未找到 — 蝌蚪吃瓜',
    description: '你访问的页面不存在或已被移动，可以回到首页继续浏览娱乐事件时间线。',
    keywords: '蝌蚪吃瓜,页面未找到',
    path: location.pathname,
  });

  return (
    <div className="mx-auto flex w-full flex-col items-center px-4 py-24 text-center md:px-6 md:py-32">
      <span className="font-heading text-7xl font-bold text-background-300 md:text-9xl">404</span>
      <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
        这条时间线不存在
      </h1>
      <p className="mt-3 max-w-lg text-sm leading-relaxed text-foreground-600">
        你访问的页面可能已被移动或链接有误。回到首页，可以从今日热瓜重新开始看起。
      </p>
      <p className="mt-2 font-label text-xs text-foreground-400">{location.pathname}</p>
      <div className="mt-7 flex flex-col gap-3 sm:flex-row">
        <Link
          to="/"
          className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 font-label text-sm text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
        <Link
          to="/timeline"
          className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 font-label text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          浏览事件合集
          <i className="ri-arrow-right-line" />
        </Link>
      </div>
    </div>
  );
}